export interface ThemePreset {
  name: string;
  label: string;
}

export const themePresets: ThemePreset[] = [
  // — Purple / Indigo family
  { name: 'helical',    label: 'Helical'    },
  { name: 'cosmic',     label: 'Cosmic'     },
  { name: 'orchid',     label: 'Orchid'     },
  { name: 'dusk',       label: 'Dusk'       },
  { name: 'lavender',   label: 'Lavender'   },
  // — Blue family
  { name: 'ohif',       label: 'OHIF Blue'  },
  { name: 'sapphire',   label: 'Sapphire'   },
  { name: 'ocean',      label: 'Ocean'      },
  { name: 'deep',       label: 'Deep'       },
  { name: 'arctic',     label: 'Arctic'     },
  // — Cyan / Green family
  { name: 'aqua',       label: 'Aqua'       },
  { name: 'turquoise',  label: 'Turquoise'  },
  { name: 'verdant',    label: 'Verdant'    },
  { name: 'sage',       label: 'Sage'       },
  { name: 'forest',     label: 'Forest'     },
  // — Neutral / Grey family
  { name: 'midnight',   label: 'Midnight'   },
  { name: 'storm',      label: 'Storm'      },
  { name: 'slate',      label: 'Slate'      },
  { name: 'neon',       label: 'Neon'       },
  // — Warm family
  { name: 'saffron',    label: 'Saffron'    },
  { name: 'gold',       label: 'Gold'       },
  { name: 'ember',      label: 'Ember'      },
  { name: 'copper',     label: 'Copper'     },
  { name: 'sienna',     label: 'Sienna'     },
  { name: 'coral',      label: 'Coral'      },
  // — Red / Pink / Magenta family
  { name: 'crimson',    label: 'Crimson'    },
  { name: 'cherry',     label: 'Cherry'     },
  { name: 'rose',       label: 'Rose'       },
  { name: 'magenta',    label: 'Magenta'    },
  { name: 'plum',       label: 'Plum'       },
];

export const DEFAULT_THEME = 'helical';
